// import schools from '../../public/data/schools.json'

export function ajaxFindSchool (query, schools) {
	return new Promise((resolve) => {
		setTimeout(() => {
			const results = schools.filter((element) => {
				// console.log(element);
				return element.INSTNM.toLowerCase().includes(query.toLowerCase())
			})
			resolve(results)
		}, 500)
	})
}